import * as React from 'react';
import * as styles from './FullVideoPlayer.module.scss';
import clsx from 'clsx';
import { VideoPlayer, VideoPlayerProps } from '../videoPlayer/VideoPlayer';

type FullVideoPlayerProps = {
  url: string;
  className?: string;
  style?: React.CSSProperties;
} & VideoPlayerProps;

export const FullVideoPlayer = ({ url, className, style, ...props }: FullVideoPlayerProps) => (
  <div className={clsx(styles.videoPlayer, className)} style={style}>
    <VideoPlayer url={url} width="100%" height="100%" className={styles.videoPlayer__video} controls {...props} />
  </div>
);
